module.exports = __webpack_public_path__ + "img/advantage1Green.e1efe935.png";